
class ServiceRequestQuotation {
    static restructureQuotation(quotation, data) {
        let serviceRequestQuotation = {}
        let productMeta = [];
        const pendingStatus = data.statusList.find((i) => i.code === "pending");
        if (data.payload.type === 'detail-product') {
            productMeta = data.detailProductData;
        }
        else if (data.payload.type === 'detail-labor-cost') {
            productMeta = data.detailedLaborCosts;
        }
        else {
            productMeta = [];
        }
        if (data.vendorId) {
            serviceRequestQuotation = {
                description: quotation.description,
                total: parseFloat(quotation.total),
                isLaborCost: data.payload.type === 'labor-cost' || data.payload.type === 'detail-labor-cost' ? true : false,
                isDetailed: data.payload.type === 'detail-product' || data.payload.type === 'detail-labor-cost' ? true : false,
                requestedBy: data.vendorId,
                productMeta,
                statusId: pendingStatus.statusId,
            }

        } else {
            serviceRequestQuotation = {
                description: quotation.description,
                total: parseFloat(quotation.total),
                isLaborCost: data.payload.type === 'labor-cost' || data.payload.type === 'detail-labor-cost' ? true : false,
                isDetailed: data.payload.type === 'detail-product' || data.payload.type === 'detail-labor-cost' ? true : false,
                productMeta,
                statusId: pendingStatus.statusId,

            }
        };
        return serviceRequestQuotation;
    }
}

export default ServiceRequestQuotation